export const alert = {
	timeout: 5000,
};
